import hyphenate from 'hyphenate-style-name';
import mq from './mediaQuery';

var negate = function negate(cond) {
  return "not ".concat(cond);
};

var keyVal = function keyVal(k, v) {
  var realKey = hyphenate(k); // px shorthand

  if (typeof v === 'number') {
    v = "".concat(v, "px");
  }

  if (v === true) {
    return realKey;
  }

  if (v === false) {
    return negate(realKey);
  }

  return "(".concat(realKey, ": ").concat(v, ")");
};

var join = function join(conds) {
  return conds.join(' and ');
};

var toQuery = function toQuery(obj) {
  var rules = [];
  Object.keys(mq.all).forEach(function (k) {
    var v = obj[k];

    if (v != null) {
      rules.push(keyVal(k, v));
    }
  });
  return join(rules);
};

export default toQuery;